var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPillarLogomark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 181.37 157.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #2e368f;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M95.29,40.58L71.86,0H0l90.69,157.35,9.83-17.06L43.19,41l52.1-.42ZM28.47,15.5h33.82l4.71,8.84h-33.43l-5.1-8.84Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "97.55 44.48 78.57 44.48 91.95 67.6 82.88 67.6 69.53 44.48 49.71 44.48 102.77 136.39 102.77 136.39 112.67 119.21 112.67 119.21 92.68 84.59 101.66 84.42 117.2 111.34 126.65 94.95 116.34 77.04 97.55 44.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "167.34 24.34 167.34 24.34 134.5 24.34 109.63 24.34 104.72 15.5 134.5 15.5 172.44 15.5 172.44 15.5 181.37 0 90.69 0 76.21 0 99.61 40.54 138.48 40.23 128.64 57.27 123.72 48.75 104.35 48.75 104.35 48.75 128.98 90.9 128.98 90.91 167.34 24.34"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPillarLogomark);
export default __webpack_public_path__ + "static/media/Pillar_Logomark.11c156a8f173b029ee87c25694b9115f.svg";
export { ForwardRef as ReactComponent };